import React from 'react'
import { Redirect } from 'react-router-dom'
import validations from '../helper/validationHelper'
import errorHandlerHelper from '../helper/errorHandlerHelper';

class Signup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            fnameCss: 'input',
            lnameCss: 'input',
            emailCss: 'input',
            passwordCss: 'input',
            buttonCSS: 'button is-success'
        }

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.handlePasswordChange = this.handlePasswordChange.bind(this)
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this)
        this.hanldeLastNameChange = this.hanldeLastNameChange.bind(this)
    }
    async handleSubmit(event) {
        try {
            event.preventDefault()
            this.setState({buttonCSS : 'button is-success is-loading'})
            let inputValidation = validations.validateAll(this.state.email, this.state.password, this.state.firstName, this.state.lastName);
            if (!inputValidation.isValidEmail) {
                this.props.showToast('error', 'Please enter a valid email!')
            }
            if (!inputValidation.isValidPassword) {
                this.props.showToast('error', 'Minimum password length is five!')
            }
            if (!inputValidation.isValidFname) {
                this.props.showToast('error', 'Enter your first name!')
            }
            if (!inputValidation.isValidLname) {
                this.props.showToast('error', 'Enter your last name!')
            }
            if (inputValidation.isAllValid && this.state.email && this.state.password) {
                let payload = {
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    email: this.state.email,
                    password: this.state.password
                }
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                }
                const response = await fetch(process.env.REACT_APP_DOMAIN + 'signup', requestOptions)
                const data = await response.json()
                if (response.ok) {
                    this.props.showToast('success','Registered successfuly! Please login')
                    this.props.history.push('/login')
                }
                else {
                    errorHandlerHelper.errorHandler(response, data, '', '', this.props.showToast)
                }
            }
        }
        catch (err) {
            this.props.showToast('error', 'Something went wrong!')
        }
        finally{
            this.setState({buttonCSS : 'button is-success'})
        }
    }
    handleEmailChange(event) {
        let cssClass = 'input'
        if (!validations.validateEmail(event.target.value)) {
            cssClass = cssClass + ' is-danger'
        }
        else {
            cssClass = cssClass + ' is-success'
        }
        this.setState({
            email: event.target.value,
            emailCss: cssClass
        })
    }
    handlePasswordChange(event) {
        let cssClass = 'input'
        if (!validations.validatePassword(event.target.value)) {
            cssClass = cssClass + ' is-danger'
        }
        else {
            cssClass = cssClass + ' is-success'
        }
        this.setState({
            password: event.target.value,
            passwordCss: cssClass
        })
    }
    handleFirstNameChange(event) {
        let cssClass = 'input'
        if (!validations.validateName(event.target.value)) {
            cssClass = cssClass + ' is-danger'
        }
        else {
            cssClass = cssClass + ' is-success'
        }
        this.setState({
            firstName: event.target.value,
            fnameCss: cssClass
        })
    }
    hanldeLastNameChange(event) {
        let cssClass = 'input'
        if (!validations.validateName(event.target.value)) {
            cssClass = cssClass + ' is-danger'
        }
        else {
            cssClass = cssClass + ' is-success'
        }
        this.setState({
            lastName: event.target.value,
            lnameCss: cssClass
        })
    }
    render() {
        if (this.props.isLoggedIn) {
            return <Redirect to='/notes'></Redirect>
        }
        return (
            <section className="hero is-fullheight-with-navbar">
                <div className="hero-body">
                    <div className="container is-max-desktop">
                        <div className="card">
                            <p className="card-header-title is-centered is-size-3">Sign Up</p>
                            <div className="card-content">
                                <div className="content">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="field">
                                            <div className="control has-icons-left ">
                                                <input className={this.state.fnameCss} type="text" placeholder="First Name" value={this.state.firstName} onChange={this.handleFirstNameChange} />
                                                <span className="icon is-small is-left">
                                                    <i className="fas fa-user"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="field">
                                            <div className="control has-icons-left ">
                                                <input className={this.state.lnameCss} type="text" placeholder="Last Name" value={this.state.lastName} onChange={this.hanldeLastNameChange} />
                                                <span className="icon is-small is-left">
                                                    <i className="fas fa-user"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="field">
                                            <p className="control has-icons-left">
                                                <input className={this.state.emailCss} type="email" placeholder="Email" value={this.state.email} onChange={this.handleEmailChange} />
                                                <span className="icon is-small is-left">
                                                    <i className="fas fa-envelope"></i>
                                                </span>
                                            </p>
                                        </div>
                                        <div className="field">
                                            <p className="control has-icons-left">
                                                <input className={this.state.passwordCss} type="password" placeholder="Password" value={this.state.password} onChange={this.handlePasswordChange} />
                                                <span className="icon is-small is-left">
                                                    <i className="fas fa-lock"></i>
                                                </span>
                                            </p>
                                        </div>
                                        <div className="field">
                                            <p className="control">
                                                <button className={this.state.buttonCSS} type="submit">
                                                    Sign Up
                                                </button>
                                            </p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Signup